import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export type ManagerialCost = {
  Id: string
  MaterialId: string
  MaterialCode: string
  Material: string
  CostValue: number
  CostExport: number
  CostDollar: number
  CompanyId: string
  CompanyCode: string
  CompanyName: string
  CostDate: string
}

type ManagerialCostStore = {
  managerialCosts: ManagerialCost[]
  resetManagerialCosts: () => void
  setManagerialCost: (managerialCost: ManagerialCost[]) => void
  updateManagerialCostStored: (managerialCost: ManagerialCost) => void
  findManagerialCostById: (id: string) => ManagerialCost | undefined
}

export const useManagerialCostStore = create<ManagerialCostStore>()(
  persist(
    (set, get) => ({
      managerialCosts: [],
      resetManagerialCosts: () => set(() => ({ managerialCosts: [] })),
      setManagerialCost: (managerialCosts: ManagerialCost[]) =>
        set(() => ({ managerialCosts })),
      findManagerialCostById: (id: string) => {
        const { managerialCosts } = get()
        return managerialCosts.find(
          (managerialCost: ManagerialCost) => managerialCost.Id === id
        )
      },
      updateManagerialCostStored: (managerialCost: ManagerialCost) =>
        set((state) => ({
          managerialCosts: state.managerialCosts.map((el) => {
            if (el.Id === managerialCost.Id) {
              return managerialCost
            }
            return el
          }),
        })),
    }),
    {
      name: 'managerial-cost-storage',
      storage: encryptedStorage(),
    }
  )
)
